import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import SEOHead from "@/components/layout/SEOHead";
import { PageHero } from "@/pages/About.hero";
import RichHtml from "@/components/RichHtml";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CustomPageView() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [state, setState] = useState("loading");

  useEffect(() => {
    setState("loading");
    axios.get(`${API}/pages/${encodeURIComponent(slug)}`)
      .then(r => { setPage(r.data); setState("ok"); })
      .catch(() => setState("missing"));
  }, [slug]);

  if (state === "loading") {
    return <div className="min-h-[40vh] flex items-center justify-center text-[color:var(--muted)]">Loading…</div>;
  }
  if (state === "missing") {
    return (
      <div className="min-h-[50vh] flex items-center justify-center px-4">
        <div className="text-center">
          <p className="eyebrow mb-3">★ 404</p>
          <h1 className="font-display text-4xl text-[color:var(--blue-ink)]">Page not found</h1>
          <p className="mt-4 text-[color:var(--ink-soft)]">
            The page &ldquo;{slug}&rdquo; either doesn&rsquo;t exist or has been unpublished.
          </p>
          <Link to="/" className="btn-primary mt-6 inline-flex">Go home</Link>
        </div>
      </div>
    );
  }

  return (
    <>
      <SEOHead
        title={page.title}
        description={page.seo_description || page.subtitle || `${page.title} - Temple Israel of Brevard`}
        path={`/pages/${page.slug}`}
      />
      <PageHero
        eyebrow="Temple Israel of Brevard"
        title={page.title}
        subtitle={page.subtitle || undefined}
      />
      {page.hero_image_url && (
        <div className="max-w-5xl mx-auto px-5 lg:px-10 -mt-2 mb-6">
          <img
            src={page.hero_image_url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${page.hero_image_url}` : page.hero_image_url}
            alt=""
            className="w-full rounded-2xl object-cover"
            style={{ maxHeight: "420px" }}
          />
        </div>
      )}
      <section className="bg-white py-10 lg:py-16">
        <div className="max-w-3xl mx-auto px-5 lg:px-10">
          <RichHtml html={page.body} />
        </div>
      </section>
    </>
  );
}
